// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leaflet-container {\n  -webkit-filter: grayscale(100%);\n  border: 2px solid rgb(var(--font-color));\n  filter: grayscale(100%);\n\n  height: 210px;\n  margin-top: 7px;\n}\n", ""]);
// Exports
module.exports = exports;
